export const DECEASED_PET_NUMBER_OF_DAYS_TO_SHOW = 28;

export const COMPANY_PHONE_NUMBER = '0330 9128077';

export const ACCESS_TOKEN_KEY = 'access_token';
export const REFRESH_TOKEN_EXPIRES_AT_KEY = 'refresh_token_expires_at';
export const B2C_ID_TOKEN_KEY = 'b2c_id_token';
export const EMAIL_ACTIVATION_LINK_SENT = 'EMAIL_ACTIVATION_LINK_SENT';

export const INFO = 'INFO';

export const STRIPE_CHECKOUT_ORIGIN = 'https://checkout.stripe.com';

// Identibase subscriptions
export const IDENTIBASE_PLUS_SUBSCRIPTION = 'IDENTIBASE_PLUS_SUBSCRIPTION';
export const IDENTIBASE_PLUS_SUBSCRIPTION_CHANGE_OF_DETAILS = 'IDENTIBASE_PLUS_SUBSCRIPTION_CHANGE_OF_DETAILS';
export const IDENTIALERT_SUBSCRIPTION_YEARLY = 'IDENTIALERT_SUBSCRIPTION_YEARLY';
export const IDENTIALERT_SUBSCRIPTION_MONTHLY = 'IDENTIALERT_SUBSCRIPTION_MONTHLY';
export const TRANSFER_OF_KEEPERSHIP_PLUS_IDENTIALERT = 'TRANSFER_OF_KEEPERSHIP_PLUS_IDENTIALERT';
export const TRANSFER_OF_KEEPERSHIP_BREEDER = 'TRANSFER_OF_KEEPERSHIP_BREEDER';
export const SMART_TAG_SUBSCRIPTION = 'SMART_TAG_YEARLY';
export const SMART_TAG_PHYSICAL_TAG = 'SMART_TAG_PHYSICAL';

export const IDENTIBASE_PLUS_SUBSCRIPTION_ADESTRA_TAG = 'identibase+';
export const IDENTIBASE_PLUS_SUBSCRIPTION_CHANGE_OF_DETAILS_ADESTRA_TAG = 'identibase+cod';
export const IDENTIALERT_SUBSCRIPTION_ADESTRA_TAG = 'identialert';
export const UNIDENTIFIED_SUBSCRIPTION_ADESTRA_TAG = 'unidentified';
export const TRANSFER_OF_KEEPERSHIP_PLUS_IDENTIALERT_ADESTRA_TAG = 'tok';
export const TRANSFER_OF_KEEPERSHIP_BREEDER_ADESTRA_TAG = 'breeder';
export const FOUR_WEEKS_FREE_EMAIL_ADESTRA_TAG = 'petplan4weeksfree';
export const SCROLL_TO_OFFERS_QUERYPARAM = 'offers';

export const IDENTIBASE_PLUS_SUBSCRIPTION_ID = 'identibase+';
export const IDENTIBASE_PLUS_SUBSCRIPTION_NAME = 'Identibase Plus';
export const IDENTIBASE_PLUS_SUBSCRIPTION_PRICE = 15;

export const IDENTIBASE_PLUS_SUBSCRIPTION_CHANGE_OF_DETAILS_ID = 'identibase+cod';
export const IDENTIBASE_PLUS_SUBSCRIPTION_CHANGE_OF_DETAILS_NAME = 'Identibase Plus and change of details';
export const IDENTIBASE_PLUS_SUBSCRIPTION_CHANGE_OF_DETAILS_PRICE_PER_YEAR = 15;

export const IDENTIALERT_SUBSCRIPTION_ID = 'identialert';
export const IDENTIALERT_SUBSCRIPTION_NAME = 'Identialert';
export const IDENTIALERT_SUBSCRIPTION_PRICE_PER_YEAR = 39;
export const IDENTIALERT_SUBSCRIPTION_PRICE_PER_MONTH = 4.99;

export const UNIDENTIFIED_SUBSCRIPTION_ID = 'unidentified';
export const UNIDENTIFIED_SUBSCRIPTION_NAME = 'Unidentified';
export const UNIDENTIFIED_SUBSCRIPTION_PRICE = 0;

export const TRANSFER_OF_KEEPERSHIP_PLUS_IDENTIALERT_ID = 'tok';
export const TRANSFER_OF_KEEPERSHIP_PLUS_IDENTIALERT_NAME = 'Transfer of Keepership';
export const TRANSFER_OF_KEEPERSHIP_PLUS_IDENTIALERT_PRICE = 39;

export const TRANSFER_OF_KEEPERSHIP_BREEDER_ID = 'breeder';
export const TRANSFER_OF_KEEPERSHIP_BREEDER_NAME = 'Transfer of Keepership Breeder';
export const TRANSFER_OF_KEEPERSHIP_BREEDER_PRICE = 39;

export const FOUR_WEEKS_FREE_EMAIL_ID = 'petplan4weeksfree';
export const FOUR_WEEKS_FREE_EMAIL_NAME = 'Petplan 4 weeks free insurance';
export const FOUR_WEEKS_FREE_EMAIL_PRICE = 0;

// Locator plan
export const SMART_TAG_SUBSCRIPTION_ID = 'locator';
export const SMART_TAG_SUBSCRIPTION_NAME = 'Locator';
export const SMART_TAG_SUBSCRIPTION_PRICE = 39;

// Petlog subscriptions
export const PETLOG_SECURE_SUBSCRIPTION = 'PETLOG_SECURE_SUBSCRIPTION';
export const PETLOG_SECURE_SUBSCRIPTION_CHANGE_OF_DETAILS = 'PETLOG_SECURE_SUBSCRIPTION_CHANGE_OF_DETAILS';
export const PETLOG_REUNITE_SUBSCRIPTION = 'PETLOG_REUNITE_SUBSCRIPTION';
export const PETLOG_REUNITE_OVERSEAS = 'PETLOG_REUNITE_OVERSEAS';

export const PETLOG_SECURE_SUBSCRIPTION_ID = 'petlog_secure';
export const PETLOG_SECURE_SUBSCRIPTION_NAME = 'Petlog Secure';
export const PETLOG_SECURE_SUBSCRIPTION_PRICE = 15;

export const PETLOG_SECURE_SUBSCRIPTION_CHANGE_OF_DETAILS_ID = 'petlog_secure+cod';
export const PETLOG_SECURE_SUBSCRIPTION_CHANGE_OF_DETAILS_NAME = 'Petlog Secure and change of details';
export const PETLOG_SECURE_SUBSCRIPTION_CHANGE_OF_DETAILS_PRICE = 15;

export const PETLOG_REUNITE_SUBSCRIPTION_ID = 'petlog_reunite';
export const PETLOG_REUNITE_SUBSCRIPTION_NAME = 'Petlog Reunite';
export const PETLOG_REUNITE_SUBSCRIPTION_PRICE = 39;

export const PETLOG_REUNITE_OVERSEAS_ID = 'petlog_reunite_overseas';
export const PETLOG_REUNITE_OVERSEAS_NAME = 'Petlog Reunite Overseas';
export const PETLOG_REUNITE_OVERSEAS_PRICE = 39;

export enum UpdatedAfterThirdPartyCommunicationUserState {
  NotUpdated = 0,
  NotAffected = 1,
  Updated = 2,
}

export enum ActivateEmailStates {
  OngoingActivation,
  Activated,
  FailedActivation,
}

export enum BRAND_ENUM {
  PETLOG = 'petlog',
  DEFAULT = 'default',
}
